import {Utils} from '../../common/scripts/utils';

// TODO: j-селекторы!!!
const fullNav = document.querySelector('.j-full-nav');
const wrapper = document.querySelector('.j-wrapper');
const header = document.querySelector('.j-header');
const headerMenuBtns = Array.from(document.querySelectorAll('.header__nav-btn'));
const headerMenuTitles = [...document.querySelectorAll('.full-nav__menu-title')];
const headerMenuListTitle = document.querySelector('.full-nav__menu-list-title');
const activeClass = 'is-active';

headerMenuBtns.forEach((button) => {
    button.addEventListener('click', () => {
        button.classList.toggle(activeClass);
        wrapper.classList.toggle(activeClass);
        fullNav.classList.toggle(activeClass);
        header.classList.toggle(activeClass);
        if (header.classList.contains(activeClass)) {
            Utils.bodyFixed(fullNav);
        } else {
            Utils.bodyStatic();
        }
        if (header.classList.contains(activeClass)) {
            document.addEventListener('click', (event) => {
                const withinBoundaries = event.composedPath().includes(header);

                if (!withinBoundaries) {
                    button.classList.remove(activeClass);
                    wrapper.classList.remove(activeClass);
                    fullNav.classList.remove(activeClass);
                    header.classList.remove(activeClass);
                    Utils.bodyStatic();
                }
            });
        }
    });
});

headerMenuTitles.forEach((item) => {
    item.addEventListener('click', () => {
        item.classList.toggle(activeClass);
        item.nextElementSibling.classList.toggle(activeClass);
    });
});

headerMenuListTitle && headerMenuListTitle.addEventListener('click', () => {
    headerMenuListTitle.classList.toggle(activeClass);
    headerMenuListTitle.nextElementSibling.classList.toggle(activeClass);
});
